import React from 'react'

export default class Tab extends React.Component{
    render() {
        return this.props.children
    }
}
